import{EventBus as n}from"../../utils/EventBus.js";function e(){window.eventBus=new n("event-bus")}function t(){return window.eventBus}export{e as eventBusInit,t as getEventBus};
//# sourceMappingURL=index.js.map
